import { Injectable } from '@angular/core';
import { CallTag } from '../../classes/callTag';

import { Auth } from '../auth.service';
import { RequestService } from '../request.service';
import { UserService } from '../users/user.service';

@Injectable()
export class CallTagService extends UserService{

  constructor(
    protected requestService: RequestService,
    protected auth: Auth
  ) { super(requestService, auth); }

  protected getUsersUrl(): string {

    return 'callTags';
  };

  protected getOneUserUrl(): string {
    return 'callTag';
  };

  protected parseObject(obj: any): CallTag {

    return obj as CallTag;
  };

  protected parseArray(objs: any): CallTag[] {

    return objs as CallTag[];
  };

  public createCallTag(name): Promise<any> {
    return this.requestService.makeRequest({
      body: {
        name: name
      },
      method: 'post'
    }, '/callTag')
    .then((response: any) => {
      return response._body;
    });
  }

  public getOne(id:string): Promise<any> {
    return this.requestService.makeRequest({
      method: 'get'
    }, '/callTag/' + id)
    .then((response: any) => {
      return response._body;
    })
  }


  public getAll(): Promise<any> {
    return this.requestService.makeRequest({
      method: 'get',
      urlQueryParams: {limit:1000}
    }, '/callTags')
    .then((response: any) => {
      return response._body;
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/services/callTag/call.tag.service.ts